import { BootstrapOptions } from 'mini-bootstrap';
import { getCurrentModule } from 'mini-app-module-store/lib/selectors/getCurrentModule';
import { Module } from 'mini-common-schema';
import { updateModuleForVdirChange } from './utils/updateModuleForVdirChange';
import type { RouteGenerator } from 'owa-router';

const moduleToMainComponentMap: { [P in Module]?: BootstrapOptions } = {};
const moduleToRouteGenerator: { [P in Module]?: RouteGenerator } = {};

export function registerBootstrapOptions(options: BootstrapOptions) {
    const module = options.appModuleProps.module;

    if (options.routerOptions) {
        options.routerOptions.routeGenerator.then(generator => {
            moduleToRouteGenerator[module] = generator;
        });

        // Handle module switches that might happen on browser back button clicks
        options.routerOptions.setModuleForVdir = () => {
            // Clear only when back button click results in module change.
            // False positive which needs to be fixed at owa-router level
            if (getCurrentModule() !== options.appModuleProps.module) {
                updateModuleForVdirChange(options);
            }
        };

        // We only need to register the global route generator once
        if (Object.keys(moduleToMainComponentMap).length === 0) {
            options.routerOptions.routeGenerator = options.routerOptions.routeGenerator.then(
                () => () => moduleToRouteGenerator[getCurrentModule()!]()
            );
        }
    }

    moduleToMainComponentMap[module] = options;
}

export function getBootstrapOptions(module: Module): BootstrapOptions | undefined {
    return moduleToMainComponentMap[module];
}
